import { DesignSystemProvider } from '@ice-web-app/designSystem';
import { i18n, languageStorageName } from '@ice-web-app/shared-i18n';
import { getCookie } from '@ice-web-app/shared-utils-ssr';
import { useEffect, useState } from 'react';
import AppRoutes from './portal/routes/AppRoutes';

type Direction = 'ltr' | 'rtl';

export function App() {
  const [dir, setDir] = useState<Direction>();

  useEffect(() => {
    const lang = getCookie(languageStorageName) || 'en';
    document.documentElement.setAttribute('lang', lang); // set app language on first load

    // Determine direction from i18n based on language, with fallback to cookie, then 'ltr'
    const direction = (i18n.dir(lang) as Direction) || (getCookie('dir') as Direction) || 'ltr';
    document.dir = direction; // set app direction on first load
    setDir(direction);
  }, []);

  return (
    <DesignSystemProvider dir={dir}>
      <AppRoutes />
    </DesignSystemProvider>
  );
}

export default App;
